import { useState } from "react";
import { toast } from "sonner";
import { Upload } from "lucide-react";
import { api, imgSrc } from "@/lib/api";

export function ImageUpload({ value, onChange, testId }) {
  const [busy, setBusy] = useState(false);

  const onFile = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setBusy(true);
    try {
      const fd = new FormData();
      fd.append("file", file);
      const { data } = await api.post("/admin/upload", fd);
      onChange(data.url);
      toast.success("Image uploaded");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Upload failed");
    }
    setBusy(false);
    e.target.value = "";
  };

  return (
    <div className="space-y-2">
      {value && (
        <img
          src={imgSrc(value)}
          alt="preview"
          className="h-24 w-24 object-cover border border-slate-200 bg-slate-50"
        />
      )}
      <div className="flex gap-2">
        <input
          type="text"
          value={value || ""}
          onChange={(e) => onChange(e.target.value)}
          placeholder="Image URL or upload a file"
          className="flex-1 border border-slate-300 px-3 py-2.5 text-sm focus:outline-none focus:border-pool"
          data-testid={testId}
        />
        <label
          className="inline-flex items-center gap-2 bg-slate-950 hover:bg-pool text-white text-[11px] tracking-wider uppercase font-semibold px-4 cursor-pointer transition-colors"
          data-testid={`${testId}-upload-button`}
        >
          <Upload className="h-3.5 w-3.5" /> {busy ? "…" : "Upload"}
          <input type="file" accept="image/*" className="hidden" onChange={onFile} data-testid={`${testId}-file-input`} />
        </label>
      </div>
    </div>
  );
}
